import React, { useEffect } from 'react';
import { useMsal } from '@azure/msal-react';
import { loginRequest } from '../authConfig';

const MicrosoftLogo = () => (
    <svg width="20" height="20" viewBox="0 0 21 21" aria-hidden="true">
        <rect x="1" y="1" width="9" height="9" fill="#F25022" />
        <rect x="11" y="1" width="9" height="9" fill="#7FBA00" />
        <rect x="1" y="11" width="9" height="9" fill="#00A4EF" />
        <rect x="11" y="11" width="9" height="9" fill="#FFB900" />
    </svg>
);

const Login = () => {
    const { instance } = useMsal();

    useEffect(() => {
        document.title = 'Ask Operations';
    }, []);

    const handleLogin = () => {
        instance.loginRedirect(loginRequest).catch(e => {
            console.error('Login error:', e);
        });
    };

    return (
        <div className="login-shell">
            {/* Left panel — desktop only */}
            <div className="login-left">
                <div className="login-left-inner">
                    <img src="/AwareAI-logo.png" alt="AwareAI" className="login-logo" />
                    <p className="login-overline">Operations Platform</p>
                    <h1 className="login-headline">Ask<br />Operations</h1>
                    <p className="login-subhead">The control centre for Ask Aware AI — monitor health, manage teams, and review usage.</p>
                    <div className="login-features">
                        <div className="login-feature-item">
                            <span className="login-feature-dot" />
                            <p className="login-feature-text">Monitor service health across Ask Engine and Ask Front End</p>
                        </div>
                        <div className="login-feature-item">
                            <span className="login-feature-dot" />
                            <p className="login-feature-text">Manage team access, budgets, and API keys</p>
                        </div>
                        <div className="login-feature-item">
                            <span className="login-feature-dot" />
                            <p className="login-feature-text">Review usage, audit logs, and analytics</p>
                        </div>
                    </div>
                    <p className="login-attribution">Powered by AwareAI — for Aware staff only</p>
                </div>
            </div>

            {/* Right panel — login card */}
            <div className="login-right">
                <div className="login-card">
                    {/* Logo + title shown on mobile only (left panel hidden) */}
                    <img src="/AwareAI-logo.png" alt="AwareAI" className="login-card-logo" />
                    <h1 className="login-card-title">Ask Operations</h1>

                    <p className="login-card-subtext">
                        Sign in with your Aware Microsoft 365 account to continue.
                    </p>

                    <button className="ms-signin-btn" onClick={handleLogin}>
                        <MicrosoftLogo />
                        Sign in with Microsoft
                    </button>

                    <p className="login-copyright">&copy; {new Date().getFullYear()} AwareAI. Internal use only.</p>
                </div>
            </div>
        </div>
    );
};

export default Login;

